import { render, staticRenderFns } from "./LLaLigaCompetition.vue?vue&type=template&id=7f43628b&"
import script from "./LLaLigaCompetition.vue?vue&type=script&lang=ts&"
export * from "./LLaLigaCompetition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports